module.exports = __webpack_public_path__ + "img/ZZRY_1.3d301b12.jpg";